:host {
  display: block;

  div.placeholder {
    background-color: #F5F6F7;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
  }
}
